import { useEffect } from 'react';

import { createHook, createStore, type StoreActionApi } from 'react-sweet-state';

import ProfileClient from '@atlaskit/profilecard/client';

import { useAppConfig } from '../app-config-context';

interface State {
	profileClient?: ProfileClient;
}

type StoreApi = StoreActionApi<State>;
type Actions = typeof actions;

const CACHE_MAX_AGE = 60 * 1000;

const actions = {
	createClient:
		(stargateRoot: string, enableTeamCentral = false) =>
		({ setState }: StoreApi): ProfileClient => {
			const profileClient = new ProfileClient({
				gatewayGraphqlUrl: `${stargateRoot}/graphql`,
				url: `${stargateRoot}/directory/graphql`,
				// TODO: https://product-fabric.atlassian.net/browse/TC-10338 - delete this later
				teamCentralUrl: enableTeamCentral ? `${stargateRoot}/watermelon/graphql` : undefined,
				teamCentralDisabled: !enableTeamCentral,
				// teamCentralBaseUrl: enableTeamCentral
				//   ? getConfig().teamCentralUrl
				//   : undefined,
				cacheSize: 20,
				cacheMaxAge: CACHE_MAX_AGE,
			});

			setState({ profileClient });

			return profileClient;
		},
};

const ProfileClientStore = createStore<State, Actions>({
	initialState: {},
	actions,
});

const useProfileClientState = createHook(ProfileClientStore);

export const useProfileClient = (): State['profileClient'] => {
	// const [teamCentralStore] = useTeamCentralStore();
	const [{ profileClient }, { createClient }] = useProfileClientState();
	const { stargateRoot } = useAppConfig();

	useEffect(() => {
		createClient(stargateRoot);
	}, [createClient, stargateRoot]);

	// TODO: enable team central
	// useEffect(() => {
	//   if (teamCentralStore.hasWorkspace || teamCentralStore.orgHasWorkspace) {
	//     // re-create the client and enable team central features
	//     createClient(true);
	//   }
	// }, [teamCentralStore.hasWorkspace, teamCentralStore.orgHasWorkspace]);

	return profileClient;
};
